import { Pipe, PipeTransform } from '@angular/core';
import { AccountGroupLocation } from '@galaxy/account-group';

@Pipe({
  name: 'accountCity',
})
export class AccountCityPipe implements PipeTransform {
  transform(account?: AccountGroupLocation): string {
    return [account?.city, account?.state, account?.zip].filter(Boolean).join(', ');
  }
}
